<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2">
<h2 id="pgepubid00002">CHAPTER I</h2>
</div>
<h3 class="calibre1 sigil_not_in_toc" id="pgepubid00003">AT MAYTREE COTTAGE</h3>
<p class="pindent"><span>A</span> DRY radiator coincided with a burst tyre. The second
coincidence was the proximity of Maytree Cottage
on the Horsham Road. The cottage was larger than most,
with a timbered front and a thatched roof. Standing at the
gate, Richard Gordon stopped to admire. The house dated
back to the days of Elizabeth, but his interest and admiration
were not those of the antiquary.</p>
<p class="pindent">Nor, though he loved flowers, of the horticulturist, though
the broad garden was a patchwork of colour and the fragrance
of cabbage roses came to delight his senses. Nor was it the
air of comfort and cleanliness that pervaded the place, the
scrubbed red-brick pathway that led to the door, the spotless
curtains behind leaded panes.</p>
<p class="pindent">It was the girl, in the red-lined basket chair, that arrested
his gaze. She sat on a little lawn in the shade of a mulberry
tree, with her shapely young limbs stiffly extended, a book
in her hand, a large box of chocolates by her side. Her hair,
the colour of old gold, an old gold that held life and sheen; a
flawless complexion, and, when she turned her head in his
direction, a pair of grave, questioning eyes, deeper than grey,
yet greyer than blue. . . .</p>
<p class="pindent">She drew up her feet hurriedly and rose.</p>
<p class="pindent">“I’m so sorry to disturb you,”—Dick, hat in hand, smiled
his apology—“but I want water for my poor little Lizzie.
She’s developed a prodigious thirst.”</p>
<p class="pindent">She frowned for a second, and then laughed.</p>
<p class="pindent">“Lizzie—you mean a car? If you’ll come to the back of
the cottage I’ll show you where the well is.”</p>
<p class="pindent">He followed, wondering who she was. The tiny hint of
patronage in her tone he understood. It was the tone of
matured girlhood addressing a boy of her own age. Dick,
who was thirty and looked eighteen, with his smooth, boyish
face, had been greeted in that “little boy” tone before, and
was inwardly amused.</p>
<p class="pindent">“Here is the bucket and that is the well,” she pointed.
“I would send a maid to help you, only we haven’t a maid,
and never had a maid, and I don’t think ever shall have a
maid!”</p>
<p class="pindent">“Then some maid has missed a very good job,” said Dick,
“for this garden is delightful.”</p>
<p class="pindent">She neither agreed nor dissented. Perhaps she regretted
the familiarity she had shown. She conveyed to him an
impression of aloofness, as she watched the process of filling
the buckets, and when he carried them to the car on the
road outside, she followed.</p>
<p class="pindent">“I thought it was a—a—what did you call it—Lizzie?”</p>
<p class="pindent">“She is Lizzie to me,” said Dick stoutly as he filled the
radiator of the big Rolls, “and she will never be anything else.
There are people who think she should be called ‘Diana,’ but
those high-flown names never had any attraction for me.
She is Liz—and will always be Liz.”</p>
<p class="pindent">She walked round the machine, examining it curiously.</p>
<p class="pindent">“Aren’t you afraid to be driving a big car like that?”
she asked. “I should be scared to death. It is so tremendous
and . . . and unmanageable.”</p>
<p class="pindent">Dick paused with a bucket in hand.</p>
<p class="pindent">“Fear,” he boasted, “is a word which I have expunged
from the bright lexicon of my youth.”</p>
<p class="pindent">For a second puzzled, she began to laugh softly.</p>
<p class="pindent">“Did you come by way of Welford?” she asked.</p>
<p class="pindent">He nodded.</p>
<p class="pindent">“I wonder if you saw my father on the road?”</p>
<p class="pindent">“I saw nobody on the road except a sour-looking gentleman
of middle age who was breaking the Sabbath by carrying
a large brown box on his back.”</p>
<p class="pindent">“Where did you pass him?” she asked, interested.</p>
<p class="pindent">“Two miles away—less than that.” And then, a doubt
intruding: “I hope that I wasn’t describing your parent?”</p>
<p class="pindent">“It sounds rather like him,” she said without annoyance.
“Daddy is a naturalist photographer. He takes moving
pictures of birds and things—he is an amateur, of course.”</p>
<p class="pindent">“Of course,” agreed Dick.</p>
<p class="pindent">He brought the buckets back to where he had found them
and lingered. Searching for an excuse, he found it in the
garden. How far he might have exploited this subject is a
matter for conjecture. Interruption came in the shape of a
young man who emerged from the front door of the cottage.
He was tall and athletic, good-looking. . . . Dick put his age
at twenty.</p>
<p class="pindent">“Hello, Ella! Father back?” he began, and then saw
the visitor.</p>
<p class="pindent">“This is my brother,” said the girl, and Dick Gordon nodded.
He was conscious that this free-and-easy method of getting
acquainted was due largely, if not entirely, to his youthful
appearance. To be treated as an inconsiderable boy had its
advantages. And so it appeared.</p>
<p class="pindent">“I was telling him that boys ought not to be allowed to
drive big cars,” she said. “You remember the awful smash
there was at the Shoreham cross-roads?”</p>
<p class="pindent">Ray Bennett chuckled.</p>
<p class="pindent">“This is all part of a conspiracy to keep me from getting
a motor-bicycle. Father thinks I’ll kill somebody, and Ella
thinks I’ll kill myself.”</p>
<p class="pindent">Perhaps there was something in Dick Gordon’s quick smile
that warned the girl that she had been premature in her
appraisement of his age, for suddenly, almost abruptly, she
nodded an emphatic dismissal and turned away. Dick was at
the gate when a further respite arrived. It was the man he
had passed on the road. Tall, loose-framed, grey and gaunt
of face, he regarded the stranger with suspicion in his deep-set
eyes.</p>
<p class="pindent">“Good morning,” he said curtly. “Car broken down?”</p>
<p class="pindent">“No, thank you. I ran out of water, and Miss—er——”</p>
<p class="pindent">“Bennett,” said the man. “She gave you the water, eh?
Well, good morning.”</p>
<p class="pindent">He stood aside to let Gordon pass, but Dick opened the
gate and waited till the owner of Maytree Cottage had entered.</p>
<p class="pindent">“My name is Gordon,” he said. Out of the corner of his eye
he saw Ella had turned back and stood with her brother within
earshot. “I am greatly obliged to you for your kindness.”</p>
<p class="pindent">The old man, with a nod, went on carrying his heavy burden
into the house, and Dick in desperation turned to the girl.</p>
<p class="pindent">“You are wrong when you think this is a difficult car to
drive—won’t you experiment? Or perhaps your brother?”</p>
<p class="pindent">The girl hesitated, but not so young Bennett.</p>
<p class="pindent">“I’d like to try,” he said eagerly. “I’ve never handled a
big machine.”</p>
<p class="pindent">That he could handle one if the opportunity came, he
showed. They watched the car gliding round the corner, the
girl with a little frown gathering between her eyes, Dick
Gordon oblivious to everything except that he had snatched
a few minutes’ closer association with the girl. He was behaving
absurdly, he told himself. He, a public official, an experienced
lawyer, was carrying on like an irresponsible, love-smitten
youth of nineteen. The girl’s words emphasized his
folly.</p>
<p class="pindent">“I wish you hadn’t let Ray drive,” she said. “It doesn’t
help a boy who is always wanting something better, to put
him in charge of a beautiful car . . . perhaps you don’t understand
me. Ray is very ambitious and dreams in millions. A
thing like this unsettles him.”</p>
<p class="pindent">The older man came out at that moment, a black pipe
between his teeth, and, seeing the two at the gate, a cloud
passed over his face.</p>
<p class="pindent">“Let him drive your car, have you?” he said grimly.
“I wish you hadn’t—it was very kind of you, Mr. Gordon,
but in Ray’s case a mistaken kindness.”</p>
<p class="pindent">“I’m very sorry,” said the penitent Dick. “Here he comes!”</p>
<p class="pindent">The big car spun toward them and halted before the gate.</p>
<p class="pindent">“She’s a beauty!”</p>
<p class="pindent">Ray Bennett jumped out and looked at the machine with
admiration and regret.</p>
<p class="pindent">“My word, if she were mine!”</p>
<p class="pindent">“She isn’t,” snapped the old man, and then, as though
regretting his petulance: “Some day perhaps you’ll own a
fleet, Ray—are you going to London, Mr. Gordon?”</p>
<p class="pindent">Dick nodded.</p>
<p class="pindent">“Maybe you wouldn’t care to stop and eat a very frugal
meal with us?” asked the elder Bennett, to his surprise and
joy. “And you’ll be able to tell this foolish son of mine
that owning a big car isn’t all joy-riding.”</p>
<p class="pindent">Dick’s first impression was of the girl’s astonishment.
Apparently he was unusually honoured, and this was confirmed
after John Bennett had left them.</p>
<p class="pindent">“You’re the first boy that has ever been asked to dinner,”
she said when they were alone. “Isn’t he, Ray?”</p>
<p class="pindent">Ray smiled.</p>
<p class="pindent">“Dad doesn’t go in for the social life, and that’s a fact,”
he said. “I asked him to have Philo Johnson down for a
week-end, and he killed the idea before it was born. And the
old philosopher is a good fellow and the boss’s confidential
secretary. You’ve heard of Maitlands Consolidated, I suppose?”</p>
<p class="pindent">Dick nodded. The marble palace on the Strand Embankment
in which the fabulously rich Mr. Maitland operated, was
one of the show buildings of London.</p>
<p class="pindent">“I’m in his office—exchange clerk,” said the young man,
“and Philo could do a whole lot for me if dad would pull out
an invitation. As it is, I seem doomed to be a clerk for the
rest of my life.”</p>
<p class="pindent">The white hand of the girl touched his lips.</p>
<p class="pindent">“You’ll be rich some day, Ray dear, and it is foolish to
blame daddy.”</p>
<p class="pindent">The young man growled something under the hand, and
then laughed a little bitterly.</p>
<p class="pindent">“Dad has tried every get-rich-quick scheme that the mind
and ingenuity of man——”</p>
<p class="pindent">“And why?”</p>
<p class="pindent">The voice was harsh, tremulous with anger. None of them
had noticed the reappearance of John Bennett.</p>
<p class="pindent">“You’re doing work you don’t like. My God! What of
me? I’ve been trying for twenty years to get out. I’ve tried
every silly scheme—that’s true. But it was for you——”</p>
<p class="pindent">He stopped abruptly at the sight of Gordon’s embarrassment.</p>
<p class="pindent">“I invited you to dinner, and I’m pulling out the family
skeleton,” he said with rough good-humour.</p>
<p class="pindent">He took Dick’s arm and led him down the garden path
between the serried ranks of rose bushes.</p>
<p class="pindent">“I don’t know why I asked you to stay, young man,” he
said. “An impulse, I suppose . . . maybe a bad conscience.
I don’t give these young people all the company
they ought to have at home, and I’m not much of a companion
for them. It’s too bad that you should be the witness of the
first family jar we’ve had for years.”</p>
<p class="pindent">His voice and manner were those of an educated man.
Dick wondered what occupation he followed, and why it
should be so particularly obnoxious that he should be seeking
some escape.</p>
<p class="pindent">The girl was quiet throughout the meal. She sat at Dick’s
left hand and she spoke very seldom. Stealing an occasional
glance at her, he thought she looked preoccupied and troubled,
and blamed his presence as the cause.</p>
<p class="pindent">Apparently no servant was kept at the cottage. She did
the waiting herself, and she had replaced the plates when the
old man asked:</p>
<p class="pindent">“I shouldn’t think you were as young as you look, Mr.
Gordon—what do you do for a living?”</p>
<p class="pindent">“I’m quite old,” smiled Dick. “Thirty-one.”</p>
<p class="pindent">“Thirty-one?” gasped Ella, going red. “And I’ve been
talking to you as though you were a child!”</p>
<p class="pindent">“Think of me as a child at heart,” he said gravely. “As
to my occupation—I’m a persecutor of thieves and murderers
and bad characters generally. My name is Richard Gordon——”</p>
<p class="pindent">The knife fell with a clatter from John Bennett’s hand and
his face went white.</p>
<p class="pindent">“Gordon—Richard Gordon?” he said hollowly.</p>
<p class="pindent">For a second their eyes met, the clear blue and the faded
blue.</p>
<p class="pindent">“Yes—I am the Assistant Director of Prosecutions,” said
Gordon quietly. “And I have an idea that you and I have
met before.”</p>
<p class="pindent">The pale eyes did not waver. John Bennett’s face was
a mask.</p>
<p class="pindent">“Not professionally, I hope,” he said, and there was a
challenge in his voice.</p>
<p class="pindent">Dick laughed again as at the absurdity of the question.</p>
<p class="pindent">“Not professionally,” he said with mock gravity.</p>
<p class="pindent">On his way back to London that night his memory worked
overtime, but he failed to place John Bennett of Horsham.</p>
<div class="calibre2"><span id="Page_17" title="17"></span><div class="pg-boilerplate" id="calibre_pb_4"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?cc2cab96